import { getCore } from '../../../../../client/core/getCore';
import type { DynamicClient } from '../../../../../client/types';

type updateWalletProviderKeysForVerifiedCredentialsParams = {
  keysToUpdate: Record<string, string>;
};

export const updateWalletProviderKeysForVerifiedCredentials = (
  { keysToUpdate }: updateWalletProviderKeysForVerifiedCredentialsParams,
  client: DynamicClient
) => {
  const core = getCore(client);

  core.state.set({
    walletProviderKeyMap: {
      ...core.state.get().walletProviderKeyMap,
      ...keysToUpdate,
    },
  });
};
